import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="container-notFoundPage">
      <h1>404 - Página no encontrada</h1>
      <p>Lo sentimos, la página que buscas no existe.</p>
    </div>
  );
};

export default NotFoundPage;
